import React from 'react'
import { Box } from '@mantine/core'
import { AppButton, AppCard, AppInput, AppPasswordInput, AppStack, AppText } from '../../app/common/ui'

export default function UiShowcase () {
  return (
    <AppCard>
      <AppStack spacing="md">
        <AppText weight={700}>UI Showcase</AppText>
        <AppText size="sm" color="dimmed">
          Internal route to validate standardized primitives before broader migrations.
        </AppText>
        <Box sx={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <AppButton>Primary</AppButton>
          <AppButton variant="light">Light</AppButton>
          <AppButton variant="outline">Outline</AppButton>
        </Box>
        <AppInput label="Email" placeholder="name@example.com" />
        <AppPasswordInput label="Password" placeholder="Your password" />
      </AppStack>
    </AppCard>
  )
}
